// Bilingual certifications content
export const certifications = {
  it: {
    overline: "Certificazioni",
    title: "Standard verificati.",
    subtitle:
      "Ogni prodotto Emergent Food esce da un laboratorio certificato e tracciato. Le certificazioni non sono un dettaglio: sono la garanzia che ciò che sviluppiamo può entrare in qualsiasi mercato europeo, in qualsiasi retail, senza compromessi.",
    active: [
      {
        code: "Bollo CE",
        name: "Approval sanitario UE",
        desc: "Il nostro laboratorio possiede il Bollo CE per la produzione e distribuzione di alimenti nell'intera Unione Europea. Ogni singolo lotto viene tracciato con il numero identificativo dell'impianto.",
        detail: "Autorità competente: Ministero della Salute · Aggiornato annualmente",
      },
      {
        code: "HACCP",
        name: "Sistema di autocontrollo alimentare",
        desc: "Piano HACCP completo con analisi dei rischi, punti critici di controllo, monitoraggio in linea, azioni correttive e verifica documentale. Audit interni ogni 3 mesi.",
        detail: "Standard: Reg. (CE) 852/2004 · Audit: trimestrali",
      },
    ],
    roadmap: [
      {
        code: "BRC Food Safety",
        name: "Global Standard for Food Safety v9",
        desc: "In implementazione per apertura ai retailer UK e nordeuropei che lo richiedono come standard di ingresso.",
      },
      {
        code: "IFS Food",
        name: "International Featured Standard v8",
        desc: "In pipeline per l'ingresso nelle catene retail francesi, tedesche e olandesi. Certificazione prevista prima dell'apertura del secondo laboratorio.",
      },
      {
        code: "IFS Broker",
        name: "Standard per intermediari private label",
        desc: "Roadmap 2027 per abilitare progetti private label con distributori europei.",
      },
      {
        code: "Biologico UE",
        name: "Reg. (CE) 834/2007 + 848/2018",
        desc: "Linea dedicata per clienti che sviluppano prodotti bio. Certificazione a progetto.",
      },
    ],
    principles_title: "Come lavoriamo la qualità.",
    principles: [
      {
        n: "01",
        h: "Tracciabilità totale",
        p: "Ogni ingrediente entra con il proprio codice lotto e viene ricondotto al prodotto finito. La supply chain è auditabile end-to-end.",
      },
      {
        n: "02",
        h: "Nessun ittico, nessuna contaminazione",
        p: "Il nostro laboratorio è ittico-free per scelta strutturale. Il rischio di cross-contaminazione con pesce, molluschi o crostacei è pari a zero.",
      },
      {
        n: "03",
        h: "Panel sensoriali indipendenti",
        p: "Ogni nuova ricetta viene validata da un panel esterno prima della certificazione shelf-life. La qualità percepita è misurata, non dichiarata.",
      },
      {
        n: "04",
        h: "Etichettatura conforme UE 1169/2011",
        p: "Ingredienti, allergeni, valori nutrizionali e claim sono sviluppati in-house con doppia verifica legale. Compatibilità multilingua per 27 mercati.",
      },
    ],
    docs_title: "Documentazione su richiesta",
    docs_sub:
      "Per audit di conformità, tender di retailer o procedure di listing, il nostro team fornisce l'intero pacchetto di certificazioni entro 48 ore.",
    docs_cta: "Richiedi la documentazione",
  },
  en: {
    overline: "Certifications",
    title: "Verified standards.",
    subtitle:
      "Every Emergent Food product leaves a certified, traceable facility. Certifications are not a detail — they are the guarantee that what we develop can enter any European market, any retailer, without compromise.",
    active: [
      {
        code: "CE Approval",
        name: "EU sanitary approval",
        desc: "Our facility holds CE approval for food production and distribution across the entire European Union. Every single batch is traced through the facility ID number.",
        detail: "Authority: Italian Ministry of Health · Renewed annually",
      },
      {
        code: "HACCP",
        name: "Food self-monitoring system",
        desc: "Complete HACCP plan with hazard analysis, critical control points, in-line monitoring, corrective actions and document verification. Internal audits every 3 months.",
        detail: "Standard: EC Reg. 852/2004 · Audits: quarterly",
      },
    ],
    roadmap: [
      {
        code: "BRC Food Safety",
        name: "Global Standard for Food Safety v9",
        desc: "Being implemented to open access to UK and Northern European retailers that require it as an entry standard.",
      },
      {
        code: "IFS Food",
        name: "International Featured Standard v8",
        desc: "In the pipeline for entry into French, German and Dutch retail chains. Certification expected before the opening of the second facility.",
      },
      {
        code: "IFS Broker",
        name: "Standard for private-label brokers",
        desc: "2027 roadmap to enable private-label projects with European distributors.",
      },
      {
        code: "EU Organic",
        name: "EC Reg. 834/2007 + 848/2018",
        desc: "Dedicated line for clients developing organic products. Certification per project.",
      },
    ],
    principles_title: "How we deliver quality.",
    principles: [
      {
        n: "01",
        h: "Total traceability",
        p: "Every ingredient enters with its own lot code and is linked to the final product. The supply chain is auditable end-to-end.",
      },
      {
        n: "02",
        h: "No seafood, no cross-contamination",
        p: "Our facility is structurally seafood-free. The risk of cross-contamination with fish, molluscs or crustaceans is zero.",
      },
      {
        n: "03",
        h: "Independent sensory panels",
        p: "Every new recipe is validated by an external panel before shelf-life certification. Perceived quality is measured, not claimed.",
      },
      {
        n: "04",
        h: "EU 1169/2011-compliant labelling",
        p: "Ingredients, allergens, nutritional values and claims are developed in-house with double legal verification. Multilingual compatibility for 27 markets.",
      },
    ],
    docs_title: "Documentation on request",
    docs_sub:
      "For compliance audits, retailer tenders or listing procedures, our team delivers the full certifications package within 48 hours.",
    docs_cta: "Request documentation",
  },
};
